import { Component, effect, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'al-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports: [CommonModule],
})
export class ModalComponent {
  show = input<boolean>(false);
  title = input<string>('');
  footerDivider = input<boolean>(true);
  hideClose = input<boolean>(false);

  closed = output<void>();

  isOpen = signal<boolean>(false);

  constructor() {
    effect(() => {
      this.isOpen.set(this.show());
    });
  }

  crossClicked(): void {
    this.closed.emit();
  }
}
